
// import  { useEffect, useState } from 'react';
// import sider from '../assets/sider.png';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { getCookie } from "../utils/cookieUtil";

// function Sidebar() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [permission, setPermission] = useState('');
//   const [isDropdownOpen, setIsDropdownOpen] = useState(false);

//   useEffect(() => {
//     const roles = getCookie('roleId');
//     if (roles) {
//       setPermission(`${roles} `);
//     }
//   }, []);

//   const handleAddUserClick = () => {
//     setIsDropdownOpen((prev) => !prev);
//   };

//   const ToAddAdminUser = () => {
//     navigate('/app/addadminuser');
//   };

//   const ToAddAppUser = () => {
//     navigate('/app/addappuser');
//   };

//   const ToAddFaculty = () => {
//     navigate('/app/addfaculty');
//   };

//   const goToHome = () => {
//     setIsDropdownOpen(false);
//     navigate('/app');
//   };

//   const goToAdminManagment = () => {
//     setIsDropdownOpen(false);
//     navigate('/app/Admindetails');
//   };

//   const goToAddUser = () => {
//     setIsDropdownOpen(false);
//     navigate('/app/adduser');
//   };

//   return (
//     <aside className="min-h-[100vh] bg-[#900028] border border-white/10 shadow-2xl p-4 flex flex-col items-center  max-w-7xl mx-auto 2xl:pt-12 2xl:pb-8 lg:pt-6 lg:pb-2 px-4">

//       {/* Logo Section */}
//       <div className="mb-8">
//         <img
//           src={sider}
//           alt="sider"
//           className="w-14 h-14 md:w-48 md:h-28"
//         />
//       </div>

//       {/* Nav Buttons */}
//       <nav className="flex flex-col w-full text-white gap-y-9">
//         <button
//           onClick={() => navigate('/app')}
//           className={`flex items-center text-left px-4 py-1 font-medium border-l-4 border-b-2 border-b-[#ba0034] ${location.pathname === '/app' ? 'border-l-[#07B9EA]' : 'border-l-transparent'
//             }`}
//         >
//           Dashboard
//         </button>


//         <button
//           onClick={() => navigate('/app/registration')}
//           className={`flex items-center text-left px-4 py-1 font-medium border-l-4 border-b-2 border-b-[#ba0034] ${location.pathname === '/app/registration' ? 'border-l-[#07B9EA]' : 'border-l-transparent'
//             }`}
//         >
//           Registration
//         </button>

//         <button
//           onClick={goToAdminManagment}
//           className={`flex items-center text-left px-4 py-1 font-medium border-l-4 border-b-2 border-b-[#ba0034] ${location.pathname === '/app/Admindetails' ? 'border-l-[#07B9EA]' : 'border-l-transparent'
//             }`}
//         >
//           Admin
//         </button>
//         <button
//           onClick={() => navigate('/app/audittrail')}
//                  className={`flex items-center text-left px-4 py-1 font-medium border-l-4 border-b-2 border-b-[#ba0034] ${location.pathname === '/app/audittrail' ? 'border-l-[#07B9EA]' : 'border-l-transparent'
//             }`}
//             >
//           Audit Trail
//         </button>
//       </nav>
//     </aside>
//   );
// }

// export default Sidebar;


import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import sider from '../assets/sider.png';
import { getCookie } from "../utils/cookieUtil";
import { MenuIcon, XIcon } from '@heroicons/react/outline';

function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [permission, setPermission] = useState('');
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    const roles = getCookie('roleId');
    if (roles) {
      setPermission(`${roles}`);
    }
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileOpen(!isMobileOpen);
  };

  const navItems = [
    { label: "Dashboard", path: "/app" },
    { label: "Registration", path: "/app/registration" },
    { label: "Admin", path: "/app/Admindetails" },
    { label: "Audit Trail", path: "/app/audittrail" }
  ];

  const renderNavButtons = () => (
    <nav className="flex flex-col w-full text-white gap-y-4">
      {navItems.map(item => (
        <button
          key={item.path}
          onClick={() => {
            setIsMobileOpen(false);
            navigate(item.path);
          }}
          className={`text-left px-4 py-2 font-medium border-l-4 border-b-2 border-b-[white] w-full
            ${location.pathname === item.path ? 'border-l-[white]   ' : 'border-l-transparent'}`}
        >
          {item.label}
        </button>
      ))}
    </nav>
  );

  return (
    <>
      {/* Mobile Menu Button */}
      <div className="lg:hidden flex justify-between items-center bg-[#900028] p-4 text-white shadow-md">
        <img src={sider} alt="sider" className="w-10 h-10" />
        <button onClick={toggleMobileMenu} aria-label="Toggle menu">
          {isMobileOpen ? <XIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile overlay */}
      {isMobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsMobileOpen(false)}
        />
      )}

      {/* Sidebar for larger screens and conditionally mobile */}
      <aside
        className={`fixed top-0 left-0 z-50 h-full bg-[#900028] border border-white/10 shadow-2xl p-4 flex flex-col
          text-white transition-transform duration-300 ease-in-out
          ${isMobileOpen ? 'translate-x-0' : '-translate-x-full'} 
          lg:translate-x-0 lg:static lg:min-h-screen lg:w-70 lg:flex lg:items-start`}
      >
        {/* Logo */}
        <div className="mb-8">
          <img src={sider} alt="sider" className="w-14 h-14 md:w-48 md:h-28" />
        </div>

        {/* Navigation */}
        {renderNavButtons()}
      </aside>
    </>
  );
}

export default Sidebar;
